// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".c32954b99926e031c5e8e013f2681fa0b9d33eef.chunk.bundle.js";
};